import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { StepPageWrapper } from '@Layout/index';
import { BusinessAddressForm } from './businessAddressForm/BusinessAddressForm';
import { BusinessAddressExplanation } from './components/BusinessAddressExplanation';
import { useBusinessAddressLogic } from './hooks/useBusinessAddress';
import type { ExtendedUseFormReturn } from '@Hooks/index';
import type { IBusinessAddressForm } from './businessAddressForm/businessAddressSchema';

export const BusinessAddress = () => {
  const { t } = useTranslation();
  const {
    formMethods,
    handleSubmit,
    isPending,
    defaultValues,
    countryList,
    states,
    isUS,
    selectedCountry,
  } = useBusinessAddressLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        isLoading={isPending}
        heading={t('sectionTitles.businessDetails')}
        content={t('pages.businessAddress.title')}
        headingContainerCustomStyle='mb-[5px]'>
        <BusinessAddressExplanation isUS={isUS} />
        <div className='form-provider-base'>
          <BusinessAddressForm
            formMethods={formMethods as ExtendedUseFormReturn<IBusinessAddressForm>}
            defaultValues={defaultValues}
            countryList={countryList}
            states={states}
            isUS={isUS}
            selectedCountry={selectedCountry}
          />
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
